import React from 'react';

import TradesPanel from './TradesPanel';
import ScopeDetailsPanel from './ScopeDetailsPanel';
import PriceSummaryPanel from './PriceSummaryPanel';

const ScopeSelectionTab = () => {
  return (
    <div className='rosetta-scope-container'>
      {/* Left Panel: Trade Selection */}
      <TradesPanel />

      {/* Center Panel: Scope Details */}
      <ScopeDetailsPanel />

      {/* Right Panel: Quick Summary */}
      <PriceSummaryPanel />
    </div>
  );
};

export default ScopeSelectionTab;
